// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"HorizontalScrollHeaderInfo_headerInfo__i7fWk","status":"HorizontalScrollHeaderInfo_status__VND_t"};